import { defineComponent as _defineComponent } from 'vue';
import { computed, onMounted, ref, watch } from "vue";
import { useFocusWithin } from "@/composables/useActiveElement";
import { useWorkflowStores } from "@/composables/workflowStores";
import { assertDefined } from "@/utils/assertions";
import { terminalFactory, } from "./modules/terminals";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConnectionMenu',
    props: {
        terminal: null
    },
    emits: ["closeMenu"],
    setup(__props, { emit }) {
        const props = __props;
        const menu = ref();
        const { focused } = useFocusWithin(menu);
        const activeElement = ref(0);
        const menuItem = ref();
        onMounted(() => {
            if (menuItem.value) {
                if ("length" in menuItem.value) {
                    menuItem.value[0]?.focus();
                }
                else {
                    menuItem.value.focus();
                }
            }
        });
        watch(focused, (focused) => {
            if (!focused) {
                emit("closeMenu", true);
            }
        });
        const stores = useWorkflowStores();
        const { stepStore } = stores;
        function increment() {
            if (menuItem.value && "length" in menuItem.value) {
                activeElement.value += 1;
                activeElement.value = Math.min(activeElement.value, menuItem.value.length - 1);
                menuItem.value[activeElement.value]?.focus();
            }
        }
        function decrement() {
            if (menuItem.value && "length" in menuItem.value) {
                activeElement.value = Math.max(activeElement.value - 1, 0);
                menuItem.value[activeElement.value]?.focus();
            }
        }
        function terminalToInputObject(terminal, connected) {
            const step = stepStore.getStep(terminal.stepId);
            assertDefined(step);
            const inputLabel = `${terminal.name} in step ${step.id + 1}: ${step.label}`;
            return { stepId: step.id, inputName: terminal.name, inputLabel, connected };
        }
        function inputObjectToTerminal(inputObject) {
            const step = stepStore.getStep(inputObject.stepId);
            assertDefined(step);
            const inputSource = step.inputs.find((input) => input.name == inputObject.inputName);
            return terminalFactory(inputObject.stepId, inputSource, props.terminal.datatypesMapper, stores);
        }
        const validInputs = computed(() => {
            const inputTerminals = props.terminal.validInputTerminals();
            return inputTerminals.map((inputTerminal) => terminalToInputObject(inputTerminal, false));
        });
        const connectedInputs = computed(() => {
            const inputTerminals = props.terminal.getConnectedTerminals();
            return inputTerminals.map((inputTerminal) => terminalToInputObject(inputTerminal, true));
        });
        const allElements = computed(() => {
            const allElements = [...connectedInputs.value, ...validInputs.value];
            allElements.sort((elementA, elementB) => {
                const stepIdSort = elementA.stepId - elementB.stepId;
                if (stepIdSort === 0) {
                    return (elementA.inputLabel || elementA.inputName) < (elementB.inputLabel || elementB.inputName) ? -1 : 1;
                }
                return stepIdSort;
            });
            return allElements;
        });
        function toggleConnection(inputObject) {
            if (inputObject.connected) {
                inputObjectToTerminal(inputObject).disconnect(props.terminal);
            }
            else {
                inputObjectToTerminal(inputObject).connect(props.terminal);
            }
        }
        return { __sfc: true, props, menu, focused, activeElement, menuItem, emit, stores, stepStore, increment, decrement, terminalToInputObject, inputObjectToTerminal, validInputs, connectedInputs, allElements, toggleConnection };
    }
});
